const compatModules = {};import * as Mod1 from "./discourse/components/post-voting-answer-button";
compatModules["discourse/components/post-voting-answer-button"] = Mod1;

export * as discourse$components$post__voting__answer__button$$__module from "./discourse/components/post-voting-answer-button";
export {
default as discourse$components$post__voting__answer__button$$default
} from "./discourse/components/post-voting-answer-button";
import * as Mod2 from "./discourse/components/post-voting-answer-header";
compatModules["discourse/components/post-voting-answer-header"] = Mod2;

export * as discourse$components$post__voting__answer__header$$__module from "./discourse/components/post-voting-answer-header";
export {
ORDER_BY_ACTIVITY_FILTER as discourse$components$post__voting__answer__header$$ORDER_BY_ACTIVITY_FILTER,
default as discourse$components$post__voting__answer__header$$default
} from "./discourse/components/post-voting-answer-header";
import * as Mod3 from "./discourse/components/post-voting-button";
compatModules["discourse/components/post-voting-button"] = Mod3;

export * as discourse$components$post__voting__button$$__module from "./discourse/components/post-voting-button";
export {
default as discourse$components$post__voting__button$$default
} from "./discourse/components/post-voting-button";
import * as Mod4 from "./discourse/components/post-voting-comment-actions";
compatModules["discourse/components/post-voting-comment-actions"] = Mod4;

export * as discourse$components$post__voting__comment__actions$$__module from "./discourse/components/post-voting-comment-actions";
export {
default as discourse$components$post__voting__comment__actions$$default
} from "./discourse/components/post-voting-comment-actions";
import * as Mod5 from "./discourse/components/post-voting-comment-composer";
compatModules["discourse/components/post-voting-comment-composer"] = Mod5;

export * as discourse$components$post__voting__comment__composer$$__module from "./discourse/components/post-voting-comment-composer";
export {
default as discourse$components$post__voting__comment__composer$$default
} from "./discourse/components/post-voting-comment-composer";
import * as Mod6 from "./discourse/components/post-voting-comment-editor";
compatModules["discourse/components/post-voting-comment-editor"] = Mod6;

export * as discourse$components$post__voting__comment__editor$$__module from "./discourse/components/post-voting-comment-editor";
export {
default as discourse$components$post__voting__comment__editor$$default
} from "./discourse/components/post-voting-comment-editor";
import * as Mod7 from "./discourse/components/post-voting-comment";
compatModules["discourse/components/post-voting-comment"] = Mod7;

export * as discourse$components$post__voting__comment$$__module from "./discourse/components/post-voting-comment";
export {
buildAnchorId as discourse$components$post__voting__comment$$buildAnchorId,
default as discourse$components$post__voting__comment$$default
} from "./discourse/components/post-voting-comment";
import * as Mod8 from "./discourse/components/post-voting-comments-menu-composer";
compatModules["discourse/components/post-voting-comments-menu-composer"] = Mod8;

export * as discourse$components$post__voting__comments__menu__composer$$__module from "./discourse/components/post-voting-comments-menu-composer";
export {
default as discourse$components$post__voting__comments__menu__composer$$default
} from "./discourse/components/post-voting-comments-menu-composer";
import * as Mod9 from "./discourse/components/post-voting-comments-menu";
compatModules["discourse/components/post-voting-comments-menu"] = Mod9;

export * as discourse$components$post__voting__comments__menu$$__module from "./discourse/components/post-voting-comments-menu";
export {
default as discourse$components$post__voting__comments__menu$$default
} from "./discourse/components/post-voting-comments-menu";
import * as Mod10 from "./discourse/components/post-voting-comments";
compatModules["discourse/components/post-voting-comments"] = Mod10;

export * as discourse$components$post__voting__comments$$__module from "./discourse/components/post-voting-comments";
export {
default as discourse$components$post__voting__comments$$default
} from "./discourse/components/post-voting-comments";
import * as Mod11 from "./discourse/components/post-voting-vote-controls";
compatModules["discourse/components/post-voting-vote-controls"] = Mod11;

export * as discourse$components$post__voting__vote__controls$$__module from "./discourse/components/post-voting-vote-controls";
export {
default as discourse$components$post__voting__vote__controls$$default
} from "./discourse/components/post-voting-vote-controls";
import * as Mod12 from "./discourse/components/post-voting-who-voted-list";
compatModules["discourse/components/post-voting-who-voted-list"] = Mod12;

export * as discourse$components$post__voting__who__voted__list$$__module from "./discourse/components/post-voting-who-voted-list";
export {
default as discourse$components$post__voting__who__voted__list$$default
} from "./discourse/components/post-voting-who-voted-list";
import * as Mod13 from "./discourse/components/reviewable/post-voting-comment";
compatModules["discourse/components/reviewable/post-voting-comment"] = Mod13;

export * as discourse$components$reviewable$post__voting__comment$$__module from "./discourse/components/reviewable/post-voting-comment";
export {
default as discourse$components$reviewable$post__voting__comment$$default
} from "./discourse/components/reviewable/post-voting-comment";
import * as Mod14 from "./discourse/connectors/category-custom-settings/post-voting-category-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/post-voting-category-settings"] = Mod14;

export * as discourse$connectors$category__custom__settings$post__voting__category__settings$$__module from "./discourse/connectors/category-custom-settings/post-voting-category-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$post__voting__category__settings$$default
} from "./discourse/connectors/category-custom-settings/post-voting-category-settings.gjs";
import * as Mod15 from "./discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class.gjs";
compatModules["discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class"] = Mod15;

export * as discourse$connectors$topic__above__post__stream$add__post__voting__topic__page__class$$__module from "./discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class.gjs";
export {
default as discourse$connectors$topic__above__post__stream$add__post__voting__topic__page__class$$default
} from "./discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class.gjs";
import * as Mod16 from "./discourse/initializers/custom-post-message-callbacks";
compatModules["discourse/initializers/custom-post-message-callbacks"] = Mod16;

export * as discourse$initializers$custom__post__message__callbacks$$__module from "./discourse/initializers/custom-post-message-callbacks";
export {
default as discourse$initializers$custom__post__message__callbacks$$default
} from "./discourse/initializers/custom-post-message-callbacks";
import * as Mod17 from "./discourse/initializers/extend-composer-actions";
compatModules["discourse/initializers/extend-composer-actions"] = Mod17;

export * as discourse$initializers$extend__composer__actions$$__module from "./discourse/initializers/extend-composer-actions";
export {
default as discourse$initializers$extend__composer__actions$$default
} from "./discourse/initializers/extend-composer-actions";
import * as Mod18 from "./discourse/initializers/post-voting-admin-plugin-configuration-nav";
compatModules["discourse/initializers/post-voting-admin-plugin-configuration-nav"] = Mod18;

export * as discourse$initializers$post__voting__admin__plugin__configuration__nav$$__module from "./discourse/initializers/post-voting-admin-plugin-configuration-nav";
export {
default as discourse$initializers$post__voting__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/post-voting-admin-plugin-configuration-nav";
import * as Mod19 from "./discourse/initializers/post-voting-edits";
compatModules["discourse/initializers/post-voting-edits"] = Mod19;

export * as discourse$initializers$post__voting__edits$$__module from "./discourse/initializers/post-voting-edits";
export {
default as discourse$initializers$post__voting__edits$$default
} from "./discourse/initializers/post-voting-edits";
import * as Mod20 from "./discourse/initializers/post-voting-icon";
compatModules["discourse/initializers/post-voting-icon"] = Mod20;

export * as discourse$initializers$post__voting__icon$$__module from "./discourse/initializers/post-voting-icon";
export {
default as discourse$initializers$post__voting__icon$$default
} from "./discourse/initializers/post-voting-icon";
import * as Mod21 from "./discourse/lib/post-voting-flag";
compatModules["discourse/lib/post-voting-flag"] = Mod21;

export * as discourse$lib$post__voting__flag$$__module from "./discourse/lib/post-voting-flag";
export {
default as discourse$lib$post__voting__flag$$default
} from "./discourse/lib/post-voting-flag";
import * as Mod22 from "./discourse/lib/post-voting-utilities";
compatModules["discourse/lib/post-voting-utilities"] = Mod22;

export * as discourse$lib$post__voting__utilities$$__module from "./discourse/lib/post-voting-utilities";
export {
removeVote as discourse$lib$post__voting__utilities$$removeVote,
castVote as discourse$lib$post__voting__utilities$$castVote,
whoVoted as discourse$lib$post__voting__utilities$$whoVoted
} from "./discourse/lib/post-voting-utilities";
export default compatModules;
